query DocumentEditQuery($id: ID!) {
  document(id: $id) {
    id
    title
    text
    slug
    type
    isPublished
    date
    platform {
      id
      title
    }
    language {
      id
      title
    }
  }
}
